import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { firstValueFrom } from 'rxjs';

export type EntityType = 'vehicle' | 'employee';

@Injectable({
  providedIn: 'root',
})
export class StatusSetApiService {
  http = inject(HttpClient);

  /**
   * Sets a status for an entity (vehicle or employee)
   * @param entityType - The type of entity ('vehicle' or 'employee')
   * @param entityId - The ID of the entity
   * @param status - The status text
   * @param icon - The emoji icon
   */
  setStatus(
    entityType: EntityType,
    entityId: string | number,
    status: string,
    icon: string,
  ): Promise<unknown> {
    const source$ = this.http.post(
      `${environment.apiUrl}api/status/${entityType}/`,
      {
        status,
        icon,
        [entityType]: entityId,
      },
    );
    return firstValueFrom(source$);
  }

  /**
   * Removes a status for an entity
   * @param entityType - The type of entity ('vehicle' or 'employee')
   * @param statusId - The ID of the status to remove
   */
  removeStatus(entityType: EntityType, statusId: number): Promise<unknown> {
    const source$ = this.http.delete(
      `${environment.apiUrl}api/status/${entityType}/${statusId}`,
    );
    return firstValueFrom(source$);
  }
}
